import type { PipelineStep } from "../services/api";
import { useLang } from "../hooks/useLang";

type Props = {
  steps: PipelineStep[];
};

type Item = { title: string; detail: string };

/** Servis isimlerini gizle, kullanici-dostu adimlara cevir. */
function presentable(steps: PipelineStep[], t: (k: Parameters<ReturnType<typeof useLang>["t"]>[0]) => string): Item[] {
  return (steps ?? []).map((s) => {
    if (s.stage === "retrieval") {
      const found = s.items_out ?? 0;
      return {
        title: t("pipe_retrieval_title"),
        detail:
          found > 0
            ? t("pipe_retrieval_found").replace("{n}", String(found))
            : t("pipe_retrieval_none"),
      };
    }
    if (s.dur_ms === 0) {
      return {
        title: t("pipe_generation_title"),
        detail: t("pipe_generation_skip"),
      };
    }
    return {
      title: t("pipe_generation_title"),
      detail: t("pipe_generation_done"),
    };
  });
}

export default function Pipeline({ steps }: Props) {
  const { t } = useLang();
  const items = presentable(steps, t);

  return (
    <ol className="pipeline">
      {items.map((s, i) => (
        <li key={i} className={`pipeline-step pipeline-${i === 0 ? "retrieval" : "generation"}`}>
          <div className="pipeline-num">{i + 1}</div>
          <div className="pipeline-body">
            <div className="pipeline-head">
              <span className="pipeline-engine">{s.title}</span>
            </div>
            <div className="pipeline-detail">{s.detail}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
